export default __webpack_public_path__ + "static/media/tag.2a28faf3.svg";